import { Plugin, HtmlDataProcessor } from "ckeditor5";
import { html as formatHtml } from "js-beautify";

import { DataControllerGetEvent } from "../_nonpublic/datacontroller";

export default class PrettyHtmlData extends Plugin {
  init() {
    this.editor.data.on<DataControllerGetEvent>(
      "get",
      (e) => {
        if (!(this.editor.data.processor instanceof HtmlDataProcessor)) return;
        if (e.return == null) return;

        e.return = formatHtml(e.return, {
          content_unformatted: ["pre", "math"],
        });
      },
      { priority: "lowest" },
    );
  }
}
